const AZURE_SOURCE = 'https://mewapiproxy-f7hvb2fufphra5bm.uaenorth-01.azurewebsites.net';

export {AZURE_SOURCE};